import { CSSProperties } from 'react';

import { Badge, withStyles } from '@material-ui/core';
import { STooltip } from '@setvi/shared/components';

import { COMPANIES } from 'Enums/Companies';
import { useAppContext } from 'Providers/AppProvider/AppContext';

interface Props {
  disabled?: boolean;
  style?: CSSProperties;
  type?: 'private-label' | 'strategic-vendor';
}

const StyledBadge = withStyles(() => ({
  badge: {
    position: 'relative',
    transform: 'none',
    color: (props: any) => props.color || '#fff',
    backgroundColor: (props: any) => props.bgcolor || '#572BD3'
  }
}))(Badge);

export const ProductLabel = ({
  style,
  type = 'private-label',
  disabled
}: Props) => {
  const { user } = useAppContext();
  const isPrivateLabel = type === 'private-label';
  const bgColor = isPrivateLabel ? '#572BD3' : '#EF1B81';

  if (
    ![COMPANIES.SYSCO_DEV, COMPANIES.SYSCO_PROD].includes(user.CompanyID) &&
    type === 'strategic-vendor'
  )
    return null;

  return (
    <STooltip
      title={isPrivateLabel ? 'Private Label' : 'Strategic Vendor'}
      style={style}>
      <StyledBadge
        badgeContent={isPrivateLabel ? 'P' : 'S'}
        color={disabled ? '#AFBAC6' : '#fff'}
        bgcolor={disabled ? '#EEF0F2' : bgColor}
      />
    </STooltip>
  );
};
